import { currentTokenVar } from "apollo/cache/auth";
import axios from "axios";
import config from "config";

export const assetClient = axios.create({
  baseURL: config.asset.uri,
});

assetClient.interceptors.request.use((req) => {
  const token = currentTokenVar();
  if (token) {
    req.headers.authorization = token;
  }
  req.headers["subs-client"] = config.name;
  return req;
});
